export enum GeographicLevel {
  EXTRA_WARD = 'EXTRA_WARD',

  LSOA = 'LSOA',

  LTLA = 'LTLA',

  MSOA = 'MSOA',

  OA = 'OA',

  RGN = 'RGN',

  UTLA = 'UTLA',
}
